import {put, takeEvery} from 'redux-saga/effects';
import {TYPES as CONFIRM_MAIL_TYPE} from '../creators/user.confirmEmail';


export function* fetchSuccess(action) {
    try {
        yield put({type: "CURRENT_USER_UPDATE_CONFIRME_MAIL", data : action.payload});
        // history.push('/');
    } catch (error) {
        console.log(error, "error");
        // yield put({type: LOGIN_USER_ME_FAIL, payload: action.payload.rules});
    }
}

export function* watchConfirmEmail() {
    yield takeEvery(CONFIRM_MAIL_TYPE.CREATE_SUCCESS, fetchSuccess);
}

export default watchConfirmEmail;